import React from "react";

export default function SubCategoriaNoEncontrada() {
  return (
    <div data-figma-id="5393:19871" class="alerta-no-encontrado-grande">
      
      <i class="fi fi-rr-not-found-magnifying-glass icon-no-resultado" data-figma-id="113:9509"></i>

      <p
        data-figma-id="5393:19873"
        class="id-m5ygyszm618655-alerta-no-encontrado-texto"
      >
        Lo sentimos, no se encontró la categoría
      </p>
      
    </div>
  );
}
